import { render, staticRenderFns } from "./srvLoginFrame.vue?vue&type=template&id=378d39c5&"
import script from "./srvLoginFrame.vue?vue&type=script&lang=js&"
export * from "./srvLoginFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports